import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { buildEthCashoutDraft } from '../cashout-draft-builders';
import { CashoutDraft } from '../cashout-currency.types';

@Component({
  selector: 'app-eth-form',
  templateUrl: './eth-form.component.html',
  styleUrl: '../../add-cashout.component.scss',
})
export class EthFormComponent implements OnInit {
  @Input() ctx!: any;
  @Output() draftReady = new EventEmitter<CashoutDraft>();

  readonly networkOptions = ['Ethereum', 'Arbitrum', 'Base', 'Polygon'];

  ngOnInit(): void {
    this.setCryptoDefaults();
  }

  saveTransaction(): void {
    this.setCryptoDefaults();
    const draft = buildEthCashoutDraft(this.ctx);
    if (draft) {
      this.draftReady.emit(draft);
    }
  }

  setNetwork(network: string): void {
    this.ctx.newTransactionForm.controls.account_type.setValue(network);
  }

  private setCryptoDefaults(): void {
    this.clearHiddenWalletValidators();
    if (!this.ctx.newTransactionForm.controls.account_type.value) {
      this.ctx.newTransactionForm.controls.account_type.setValue('Ethereum');
    }
  }

  private clearHiddenWalletValidators(): void {
    this.ctx.newTransactionForm.controls.company_id.clearValidators();
    this.ctx.newTransactionForm.controls.company_name.clearValidators();
    this.ctx.newTransactionForm.controls.company_id.setValue('');
    this.ctx.newTransactionForm.controls.company_name.setValue('');
    this.ctx.newTransactionForm.controls.company_id.updateValueAndValidity({
      emitEvent: false,
    });
    this.ctx.newTransactionForm.controls.company_name.updateValueAndValidity({
      emitEvent: false,
    });
  }
}
